import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckCircleFilled } from "@ant-design/icons";
import { theme } from "antd";
import { observer } from "mobx-react";
import { useStores } from "../../../../store/stores.js";
import { __ } from "../../../../utils/i18n.js";
import { markdownBold } from "../../utils/markdownBold.js";
/**
 * Product-level "why buy this" bullet list with a user-centred heading so
 * the items read as benefits to the buyer, not neutral product facts.
 * Structural styling (heading weight/size, list reset, item layout, icon
 * sizing) lives in `style/checkoutV2.scss` under `.checkout-v2-keybenefits*`;
 * colours remain inline so they track the Antd theme tokens.
 */ const KeyBenefits = observer(()=>{
    const { checkoutV2Store } = useStores();
    const { product } = checkoutV2Store;
    const { token } = theme.useToken();
    const benefits = product?.data?.productPlan?.product?.keyBenefits;
    if (!benefits || benefits.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "checkout-v2-keybenefits__heading",
                style: {
                    color: token.colorTextHeading
                },
                children: __("Your benefits")
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: "checkout-v2-keybenefits__list",
                children: benefits.map((benefit, index)=>/*#__PURE__*/ _jsxs("li", {
                        className: "checkout-v2-keybenefits__item",
                        style: {
                            color: token.colorText
                        },
                        children: [
                            /*#__PURE__*/ _jsx(CheckCircleFilled, {
                                style: {
                                    color: token.colorSuccess
                                }
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                children: markdownBold(benefit)
                            })
                        ]
                    }, index))
            })
        ]
    });
});
export { KeyBenefits };
